'use client';

import Image from 'next/image';
import { useWindowSize } from 'usehooks-ts';

import UiUtils from '@utils/ui';

export default function Testimonial(props) {
    const { logo, logoWidth, logoHeight, logoAlt, quote, avatar, avatarAlt, name, role } = props;

    const { width } = useWindowSize();
    const isMobile = UiUtils.isMobile(width);

    let quoteClass = "font-vg-regular text-black shrink grow text-2xl leading-130";
    //quoteClass = isMobile ? `${quoteClass} text-[28px]` : `${quoteClass} text-3-5xl`;

    let outerClass = "flex flex-col items-stretch gap-8 h-full py-8";
    outerClass = isMobile ? `${outerClass} gap-6` : `${outerClass} h-full gap-8`;

    return (
        <div className={outerClass}>
            {logo && (
                <div className="h-[88px] flex justify-start shrink-0 grow-0">
                    <Image 
                        src={logo} 
                        width={logoWidth}
                        height={logoHeight}
                        className="h-full w-auto" 
                        alt={logoAlt}
                    />
                </div>
            )}
            <p className={quoteClass}>&quot;{quote}&quot;</p>
            <div className="flex justify-start items-center gap-3 shrink-0 grow-0">
                {avatar && (
                    <Image 
                        src={avatar}
                        width={50}
                        height={50} 
                        className="h-[50px] w-[50px] rounded-full" 
                        alt={avatarAlt}
                    />
                )}
                <div className="flex flex-col items-start gap-1.5">
                    <p className="font-vg-book text-black text-xl leading-130">{name}</p>
                    {role && (
                        <p className="font-vg-book text-black text-base leading-130">{role}</p>
                    )}
                </div>
            </div>
        </div>
    );
}